import template from './overview.html';

class ProfileOverviewTabComponentVM
{
	constructor(params)
	{
		this.vm = params.vm;
		this.user = ko.observable(this.vm.user_data() || {});
		this.roles_str = ko.observable('');
		this.email = ko.observable('-');
		this.theme_list = ko.observableArray([]);
		this.selected_theme_mode = ko.observable();
		this.selected_theme = ko.observable();
		this.group_role_map = {};

		this.vm.user_data.subscribe((user) => {
			this.user(user || {});
			this.update_role_groups_display(user);
			this.email(user?.email || '-');
		});

		this.selected_theme_mode.subscribe((newVal) => {
			if (newVal && newVal !== Grape.themes.getMode())
				Grape.themes.setUserTheme(this.selected_theme(), newVal);
		});

		this.selected_theme.subscribe((newVal) => {
			if (newVal && newVal !== Grape.themes.getTheme())
				Grape.themes.setUserTheme(newVal, this.selected_theme_mode());
		});

		this.init();
	}

	update_role_groups_display (user)
	{
		const roleNames = user?.user_roles || [];
		const groupDisplayNames = [];
		for (const roleName of roleNames)
		{
			const mapped = this.group_role_map[roleName];
			if (mapped)
				groupDisplayNames.push(mapped);
		}
		this.roles_str(groupDisplayNames.join(', '));
	}

	async init ()
	{
		const accessRoles = await Grape.cache.fetch('AccessRoles');
		this.group_role_map = {};
		for (const role of (accessRoles || []))
			if (role.role_type == 'GROUP')
				this.group_role_map[role.role_name] = role.display_name || role.role_name;
		this.update_role_groups_display(this.user());

		const allow_user_theme = Grape?.config?.public_settings?.allow_user_theme;
		if (!allow_user_theme)
			return;

		this.selected_theme(Grape.themes.getTheme() || 'default');
		this.selected_theme_mode(Grape.themes.getMode() || 'light');
		this.theme_list(await Grape.themes.getThemes());
	}

	item_click (theme)
	{
		this.selected_theme(theme);
	}

	new_password ()
	{
		Grape.dialog.open('NewPassword');
	}
}

export default {
	name: 'profile-overview-tab',
	viewModel: ProfileOverviewTabComponentVM,
	module_type: 'ko',
	template: template
};
